import {createSlice, type PayloadAction} from "@reduxjs/toolkit";
import type {AppThunk} from "./index.ts";


export type ModalStateType = 'offline' | 'online' | 'slow' | null;
export type ModalStateData = null;

export interface ModalState {
  isOpen: boolean;
  type: ModalStateType;
  data?: ModalStateData;
}

const initialState: ModalState = {
  isOpen: false,
  type: null,
  data: null
};

const modalSlice = createSlice({
  name: 'modalbottom',
  initialState,
  reducers: {
    // 다이얼로그를 여는 액션 (type, current)
    openModal: (state: any, action: PayloadAction<Omit<ModalState, 'isOpen'>>) => {
      state.isOpen = true;
      state.type = action.payload.type;
      state.data = action.payload.data;
    },
    // 다이얼로그를 닫는 액션
    closeModal: (state: any) => {
      state.isOpen = false;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;


export const askModal = (type: ModalStateType, data: ModalStateData): AppThunk<Promise<void>> =>
  async (dispatch: any) => {
    dispatch(openModal({ type, data }));

    return new Promise<void>(() => {

    });
  };
